module.exports = __webpack_public_path__ + "static/media/open.7a49bf72.svg";